<script setup></script>

<template>
  <img src="@/assets/logos/fm-rgb-logo.png" alt="logo" class="logo" />
</template>

<style lang="scss" scoped></style>
